function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.532 4.054L13.418.09A1.022 1.022 0 0013 0H1C.85 0 .709.034.582.09l5.885 3.964c.279.188.786.188 1.065 0z",
  fill: "#F5F1E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.106 4.842A2 2 0 017 5.155c-.398 0-.796-.104-1.106-.313L.009.879C.006.907 0 .934 0 .962v8.075c0 .531.448.962 1 .962h12c.552 0 1-.43 1-.962V.962c0-.028-.006-.055-.009-.083L8.106 4.842z",
  fill: "#F5F1E3"
});

var SvgIcMail = function SvgIcMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-mail.45e84d1f.svg";
export { ForwardRef as ReactComponent };